<template>
    <div :class="{'top-menu-group': true, 'active': open}"  ref="root">
        <div class="hover"></div>
        <button class="my-top-menu-button" type="button" @click="menuClick">
            <slot name="content">
                <span>{{ name }}</span>
            </slot>
        </button>
        <teleport to="body">
            <Transition>
                <div class="top-dropdown-menu" v-if="open" :style="{top: `${top}px`, left: `${left}px`, right: right != null ? `${right}px` : undefined, marginRight: '-1000px'}" ref="menu">
                    <div class="menu-group">
                        <slot></slot>
                    </div>
                </div>
            </Transition>
            <div v-if="open" class="top-menu-overlay" @click="close" :style="{top: `${top}px`}">
            </div>
        </teleport>
    </div>
</template>

<script>
export default {
    props: ["name", "icon",],
    components: {
    },
    data() {
        return {
            open: false,
            top: 0,
            left: 0,
            right: null,
        };
    },
    mounted() {
        window.addEventListener('top-menu-group-overlay', this.close);
    },
    unmounted() {
        window.removeEventListener('top-menu-group-overlay', this.close);
    },
    methods: {
        closeAll() {
            const event = new CustomEvent('top-menu-group-overlay', {});
            window.dispatchEvent(event);
        },
        menuClick() {
            let isOpen = this.open;
            this.closeAll();

            this.open = !isOpen;
            if (this.open) {
                const maxHeight = window.innerHeight;
                const maxWidth = document.body.scrollWidth; // window.innerWidth;
                const root = this.$refs.root;
                if (root) {
                    const rect = root.getBoundingClientRect();                    
                    this.top = rect.y + rect.height;
                    
                    if (maxWidth < 1024) {
                        this.left = 0;
                        this.right = 0;
                    } else {
                        this.left = rect.x;
//                        this.right = -1000;
                        this.$nextTick(()=>{                            
                            const menu = this.$refs.menu;
                            if (menu) {
                                const menuRect = menu.getBoundingClientRect();
                                const right = this.left + menuRect.width;
                                if (right > maxWidth) {                                                                
                                    const delta = right - maxWidth;
                                    this.left = Math.max(this.left - delta, 0);
                                    if (menuRect.width > maxWidth) {
                                //        this.right = 0;
                                    }
                                }
                            }
                        });                        
                    }
                }
            }
        },
        close() {
            this.open = false;
        },
    }
}
</script>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>

<style lang="scss" scoped>
@import '@root/responsive';

    .top-menu-group {
        display: flex;
        position: relative;
        &::after {
            display: inline-block;
            margin-left: 6px;
            content: "";
            background-image: url(/static/images/redisign/new-game-catalog/chevron-down.svg);
            width: 10px;
            height: 8px;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            position: relative;
            top: 2px;
        }
        &:hover {
            //box-shadow: 0 3px 0 #6179E0;
            //z-index: 99999999;
            .hover {
                display: block;
            }
        }
        .hover {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 32px;
            height: 3px;
            background: #6179E0;
            display: none;
        }
    }
    .top-menu-group.active {
        &::after {
   //         transform: rotate(180deg);
            transform: translateY(24px);
            transition: 0.5s;
        }
    }
    .btn:focus {
        box-shadow: none;
        background: none;
        color: #212529;
    }
    .my-top-menu-button {
        background: none;
        color: #212529;
        outline: none;
        box-shadow: none;
        border: none;
        padding: 0;
        font-size: 18px;
        font-weight: 600;
        border-radius: 0;
    }
    .top-dropdown-menu {
        position: absolute;
        z-index: 999;
        background: white;
        border: solid 1px #ebebeb;
        max-width: 100%;
        transform: translateX(0%);
        .menu-group {
            min-width: 240px;
        }
    }
    .top-menu-overlay {
        position: absolute;
        z-index: 998;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0,0,0,0.2);            
    }

.v-enter-active, .v-leave-active {
  opacity: 1;
  transform: translateX(0%);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.v-enter-from, .v-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}
</style>